module.exports = __webpack_public_path__ + "static/logo-ec4bb4cde89d02e69bc9b1ea4b5fafc6.png";